import { create } from "zustand";

import { TUserAssociatedCorporation } from "@type/api/corporation/types";
import { TBooleanRecord } from "types/index";

export type TCorporation = Omit<
  TUserAssociatedCorporation,
  "roleName" | "totalMember" | "phone" | "isPublic" | "idNta"
> & {
  slug: string;
};

type TCorporationStore = {
  isLoading: boolean;
  selectedCorp?: TCorporation;
  corpAccessRight?: TBooleanRecord;
  mapCorpList?: Record<string, TCorporation>;
  onSetMapCorpList: (mapCorpList: Record<string, TCorporation>) => void;
  onSetLoading: (isLoading: boolean) => void;
  onSetSelectedCorp: (corp: TCorporation) => void;
  onSetCorpAccessRight: (access: TBooleanRecord) => void;
};

export const useCorporationStore = create<TCorporationStore>((set) => ({
  isLoading: false,
  mapCorpList: undefined,
  selectedCorp: undefined,
  corpAccessRight: undefined,
  onSetLoading: (isLoading) => {
    set({ isLoading });
  },
  onSetMapCorpList: (mapCorpList) => {
    set((state) => ({
      ...state,
      mapCorpList: {
        ...state.mapCorpList,
        ...mapCorpList,
      },
    }));
  },
  onSetSelectedCorp: (selectedCorp) => {
    set({ selectedCorp });
  },
  onSetCorpAccessRight: (corpAccessRight) => {
    set({ corpAccessRight });
  },
}));
